export default {
  BUTTON: {
    APPLY: "適用",
    NONE: "無し",
    SAVE_CHANGES: "変更を保存",
    PROCEED: "続行する",
    DISMISS: "却下する",
    CONNECT: "接続する",
    CONNECT_WALLET: "ウォレットに接続",
    DISCONNECT: "接続を解除",
    LOGOUT: "ログアウト",
    CLOSE: "閉じる",
    SETTINGS: "設定",
    LAUNCH_APP: "アプリを起動",
    CONNECT_TO_PROCEED: "ウォレットに接続",
    VIEW_DETAILS: "詳細を表示",
    REFRESH: "更新",
    START_REGISTRATION: "登録を開始",
    CANCEL: "キャンセル",
    PRESS_ENTER: "Enter キーを押します",
    LEARN_MORE: "もっと詳しく",
    CLOSE_WINDOW: "ウィンドウを閉じる",
    SHOW_AVAILABLE_ONLY: "利用可能なもののみ表示",
    SHOW_AVAILABLE: "利用可能なもののみ表示",
    PROCEED_SEARCH: "検索を続行する",
    DOWNLOAD: "ダウンロード",
    SHOW_ALL: "すべて表示",
    DESELECT_ALL: "すべての選択を解除",
    SHOW_SELCTED: "選択したものを表示",
    LINK: "リンク",
    CUSTOM_LINK: "カスタムリンク",
    SET_QR_LINK_ALL: "QRリンクをすべて設定",
    SET_QR_LINK: "QRリンクをすべて設定",
    DISABLE_ALL: "すべて無効",
    DISABLE_QR_CODE: "QRコードを無効にする",
    ENABLE_QR_CODE: "QRコードを有効にする",
    SET_QR_COLOR: "QRコードの色を設定",
    SET_COLOR: "QRコードの色を設定",
    SET_ALL_COLORS: "QRコードの色を設定",
    SET_PRICE: "価格の設定",
    SET_PRICE_ALL: "価格を全て設定",
    RESET: 'Reset',
    CHECK_PROFILE: "プロファイルを確認",
    GO_TO_DASHBOARD: "ダッシュボードに移動",
    GO_TO_HOME: "ホームへ移動",
    VIEW_PROFILE: "プロフィールを表示",
    CHECK_DOMAINS: "ドメインを確認",
    TRANSACTION_DETAILS: "トランザクションの詳細",
    BUY_NOW: "今すぐ購入",
    CLEAR_HISTORY: "履歴をクリア",
    DEFAULT: 'Default',
    CUSTOM: "カスタム",
    FRACTIONALISE: "分数化",
    MORE_INFO: "詳細",
    LESS_INFO: "簡易情報",
    APPROVE: "承認",
    NEXT: "次へ",
    PENDING: "保留中",
    REMOVE: "削除",
    REMOVE_ALL_ITEMS: "すべてのアイテムを削除",
    ADD_ALL_TO_CART: "すべてをカートに入れる",
    BOOKMARK_ALL: "すべてをブックマーク",
    DOWNLOAD_LIST: "ダウンロードリスト",
    SHARE_LIST: "リストを共有",
    MORE: "その他",
    CHANGE: "変更",
    TRY_AGAIN: "再試行"
  },
  HEADER: {
    ABOUT: "について",
    FAQ: "よくある質問",
    BACK_TO_HOME: "ホームに戻る",
    HOME: "家",
    CATEGORIES: "カテゴリ",
    HELP_SUPPORT: "ヘルプ & サポート",
    HELP: "ヘルプ",
    CANCEL_REGISTRATION: "登録をキャンセル",
    PROFILE: "プロフィール",
    SETTINGS: "設定",
    DOCS: "ドキュメント",
    DOCUMENTATIONS: "文書",
    CART: "カート",
    BOOKMARKS: "ブックマーク",
    PAYMENTS_HISTORY: "支払履歴",
    LIGHT_MODE: "ライトモード",
    CUSTOM_RPC: "カスタム RPC",
    SETUP_REQUIRED: "セットアップが必要です",
    MANAGE_DOMAINS: "ページドメイン",
    APPROVE: "承認",
    FEATURE_DISABLED: "機能の無効化",
    ERROR: "エラー"
  },
  IPFS: {
    INITIALISING: "p2pを開始",
    FINDING_PEERS: "ピアを検索中",
    FAILED: "失敗しました",
    READY: "準備完了",
    PUBLISHING: "公開"
  },
  EVENTS: {
    TRANSFER: "送金",
    REGISTRATION: "登録",
    RENEWAL: "更新",
    SALE: "販売",
    MINT: "造幣局",
    BURN: "書き込み中"
  },
  GENERIC: {
    NETWORK_CHANGED_INCOMPATIBLE: "ネットワークはサポートされていません。ネットワークを変更してください。",
    IPNS_PUBLISHING_COMPLETED: "公開完了！",
    PENDING_TRANSACTION_CERATED: "新しい取引が作成されました。ウォレットを確認してください。"
  },
  RENEWAL_DURATIONS: {
    ONE_WEEK: "1週間",
    ONE_MONTH: "1ヶ月",
    THREE_MONTHS: "3カ月",
    SIX_MONTHS: "6カ月",
    ONE_YEAR: "1年",
    TWO_YEARS: "2 年",
    THREE_YEARS: "3 年",
    FOUR_YEARS: "4 年",
    FIVE_YEARS: "5 年"
  },
  LABELS: {
    DOWNLOAD_DATA: "データをダウンロード",
    SORT_BY_EXPIRATIONS: "有効期限でソート",
    SORT_BY_LATEST_REGISTRATIONS: "最新の登録でソート",
    SORT_BY_LONGEST_DURATION: "期間の長さでソート",
    PREMIUM: "プレミアム",
    ANALYTICS: "分析",
    AN_ERROR_HAS_OCCURED: "リクエストの処理中にエラーが発生しました。",
    STOREFRONT_READY_TO_DEPLOY: "店舗が配備される準備が整いました。店舗は以下の場所にあります：",
    ACCESS_STOREFRONT: "店舗のフロントにアクセスできるようになりました：",
    BUY_ON: "購入先：",
    MY_PROFILE: "マイプロフィール",
    CREATE_STOREFRONT: "店舗を作成",
    SETUP_PRIMARY_DOMAIN: "プライマリドメインの設定",
    CHOOSE_A_PRIMARY_DOMAIN: "プライマリ・ドメインを選択し、プロフィールにリンクします。選択したドメインがプロフィールのリンクになります。",
    CREATE_YOUR_STOREFRONT: "プレドメインストアで.ethの名前を使用して店舗の前面を作成します。店舗の前面について詳しくはこちら:",
    THIS_DOMAINS_IS_AVAILABLE_IN_MARKETPLACE: "このドメインは以下のマーケットプレイスでご利用いただけます",
    PURCHASE_DOMAINS: "ドメインの購入",
    OWNED_BY: "所有人",
    SETUP_STOREFRONT: 'Setup Storefront',
    MANAGE_FEATURED_ITEMS: "注目のアイテムを管理",
    VISIT_STOREFRONT: "ストアを訪問",
    OPTIONS: "オプション",
    FEATURED_ITEMS: "おすすめ",
    SORT_BY_CATEGORY: "カテゴリでソート",
    SELECT_DOMAIN: "ドメインを選択",
    SELECT_DOMAINS: "ドメインを選択",
    RENEW_DOMAINS: "ドメインを更新",
    TRANSFER_DOMAINS: "ドメインを転送する",
    BUYER: "バイヤー",
    PRICE: "販売価格:",
    SALE: "販売",
    ACTIVITY: "アクティビティ",
    TOP_CATEGORIES: "トップカテゴリ",
    TOTAL_ASSETS: "資産の合計",
    MONTHLY_SALES: "月商",
    DAILY_VOLUME: "毎日の音量",
    MONTHLY_VOLUME: "月刊ボリューム",
    DAILY_SALES: "毎日の販売",
    TOP_SALE: "人気セール",
    TOP_SALES: "人気セール",
    TOP_BUYER: "トップバイヤー：",
    RECENT_SALES: "アプリ履歴のスタイル",
    SALES_ACTIVITY: "販売活動",
    ENTER_NAMES_TO_SEARCH: "名前を入力して検索",
    NOT_AVAILABLE: "利用できません（見つかりません、利用不可）",
    VOLUME: "音量",
    FLOOR: "床",
    FILTER: "フィルター",
    RENEWAL_DURATION: "更新期間",
    TRANSACTION: "トランザクション",
    USER_PROFILE: "ユーザープロフィール",
    FEATURE_DISABLED: "この機能は現在無効化されています",
    COMPLETE: "完了",
    ESTIMATED_COST: "料金の目安：",
    ADDRESS: "会社アクセス",
    TRANSFER: "送金",
    PLEASE_WAIT: "お待ちください",
    SELECT_A_DOMAIN: "ドメインの選択",
    RENEW: "更新",
    MANAGE_DOMAINS: "ページドメイン",
    SEARCH_FOR: "検索文字",
    MANAGE: "管理",
    COLLECT: "これを全部集めて ",
    LANDING_TEXT: "オープンソース、分散化、Web3ドメイン検索、登録、マーケットプレイス。",
    PROFILE: "プロフィール",
    GO_TO_PROFILE: "プロファイルに行く",
    SEARCH: "検索",
    CONTAIN_ALPHABET: "アルファベットが含まれています",
    CONTAIN_NUMBERS: "数字が含まれています",
    CONTAIN_EMOJI: "絵文字を含む",
    MIN_LENGTH: "最小長さ",
    MAX_LENGTH: "最大の長さ",
    CONTAINING_KEYWORDS: "キーワードを含む",
    FILTERS: "フィルタ",
    DOMAINS: "ドメイン",
    DOMAIN: "ドメイン",
    DOMAIN_HISTORY: "ドメイン履歴",
    EXPIRATION_DATE: "有効期限日",
    REGISTRATION_DATE: "登録",
    CREATION_DATE: "作成日",
    DETAILS: "詳細",
    YOUR_DOMAINS: "あなたのドメイン",
    PROCESSING: "処理中",
    LAYOUT: "レイアウト",
    ENTER_SUFFIX: "サフィックスを入力",
    ENTER_PREFIX: "サフィックスを入力",
    CLICK: 'Click',
    CONNECT_TO_START: " 始めるには ",
    TIP: 'Tip',
    ACTION: 'Action',
    ACTIONS: "操作",
    ADVANCED_SEARCH_TIP: "新しい行またはカンマを使用して、ドメインエントリを分離します。",
    ADVANCED_SEARCH: "詳細検索",
    ADVANCED_MODE: "詳細モード",
    REGISTER_DOMAINS_TO: "ドメインを登録先",
    NO_DOMAINS_SELECTED: "ドメインが選択されていません。",
    FIND_AND_REGISTER: "ドメインを検索します。例：domain1, domain2...",
    SELECTED_DOMAINS: "選択したドメイン",
    REGISTER: "登録",
    BOOKMARKS: "ブックマーク",
    SEARCH_RESULTS: "検索結果",
    PROCEED_TO_REGISTRATION: "登録に進む",
    REGISTER_DOMAINS: "ドメインを登録先",
    REGISTRANT_ADDRESS: "登録者アドレス",
    SET_RESOLVER: "リゾルバーを設定",
    TOTAL_COST: "合計コスト",
    GAS_PRICE: "ガス価格",
    NO_ADDRESS_DETECTED: "アドレスが見つかりません。",
    DURATION: "期間",
    NOTICE_SELECT_AN_RPC: "注意: デフォルトのRPCプロバイダを置き換えるためにアプリケーションで使用されるRPCを選択します。",
    ENABLE_LIGHT_MODE: "ライトのレイアウトスタイルを有効にする",
    CLICK_NEXT_TO_PROCEED: "<b>次へ</b> をクリックして進みます。"
  },
  REGISTRATION: {
    REGISTRATION_CANCELLED_TITLE: "登録をキャンセルしました",
    REGISTRATION_CANCELLED_DESCRIPTION: "あなたの登録がキャンセルされました。",
    CANCEL_REGISTRATION_TITLE: "登録をキャンセル",
    CANCEL_REGISTRATION_DESCRIPTION: "この認証を削除しても宜しいですか？ この操作を元に戻すことはできません。",
    BEFORE_COMMIT: "ステップ 1: リクエスト登録",
    COMMIT_SENT: "リクエストを処理しています...",
    COMMIT_COMPLETE: "ステップ 1: リクエスト登録",
    AWAIT: "リクエストを処理しています...",
    BEFORE_REGISTRATION: "登録の完了",
    REGISTRATION_SENT: "登録を完了中...",
    REGISTRATION_COMPLETE: "登録!",
    REGISTRATION_COMPLETE_TITLE: "登録",
    YOUR_DOMAINS_HAVE_NOW_BEEN_REGISTERED: "ドメインが登録されました。",
    BASKET_EMPTY: "カートが空です",
    PLEASE_SELECT_DOMAINS_TO_REGISTER: "登録する新しいドメインを選択してください。"
  },
  PAYMENT: {
    PAYMENT_CANCELLED: "取引がキャンセルされました。もう一度やり直してください。"
  },
  SPINNER: {
    SETUP_COMPLETE: "設定完了",
    LEDGER_NO_DEVICE_SELECTED: "クーポンを作成する時にエラーが発生しました。もう一度やり直してください。",
    NO_DATA_TO_DISPLAY: "表示する項目がありません。",
    PERFORMING_SEARCH: "検索を実行中...",
    LOADING_DATA: "データを読み込み中...",
    FOLLOW_THE_INSTRUCTIONS_ON_YOUR_WALLET: "続行するにはウォレットの指示に従ってください。"
  },
  FORM_LABELS: {
    ENTER_DURATION: "期間を入力",
    ENTER_QR_LINK: "カスタム QR コードのURLを入力してください",
    ENTER_PRICE: "価格を入力",
    ENTER_CUSTOM_ADDRESS: "カスタムアドレスを入力してください",
    ENTER_RECEIVER_ADDRESS: "受信者アドレスを入力してください"
  },
  FORM_ERRORS: {
    INVALID_DURATION: "無効な期間",
    INVALID_QR_LINK: "無効な URL です。もう一度やり直してください。",
    INVALID_PRICE: "無効な価格です。もう一度やり直してください。",
    NO_ADDRESS_DETECTED: "アドレスが見つかりませんでした。もう一度やり直してください。",
    INVALID_ADDRESS: "僅用於中文"
  },
  STEP: {
    STEP_1: "ステップ 1",
    STEP_2: "ステップ 2",
    STEP_3: "ステップ 3",
    STEP_4: "ステップ 4",
    STEP_5: "ステップ 5"
  },
  RENEW: {
    RENEWAL_COST: "更新コスト",
    ESTIMATED_RENEWAL_COST: "以下は、このトランザクションの推定更新コストです。",
    RENEWAL_COMPLETE: "更新完了",
    DOMAINS_READY_FOR_RENEWAL: " ドメインの更新が完了しました。更新を完了するには、format@@0を押します。"
  },
  TRANSFER: {
    TRANSFER_TO: "送金",
    TRANSFER_COMPLETE: "転送完了！",
    SETUP_INSTRUCTION: "ENSドメイン管理を有効にするには、ドメイン転送を承認するためにアカウントを設定する必要があります。",
    CONTRACT_APPROVAL_NOTE: "契約承認により、契約はお客様に代わってドメインの譲渡を行うことができます。",
    DOMAINS_READY_FOR_TRANSFER: "ドメインを転送する準備ができました。レシピのアドレスを入力し、続行を押してください。"
  }
};